<template>
	<BaseTooltip :text="$auth.isAuthenticated.value ? 'Attach files' : 'Login to attach files'" placement="bottom">
		<label for="file-input" class="flex file-upload cursor-pointer" :disabled="isDisabled">
			<BaseIcon
				name="mono/attachment"
				class="w-16 h-16 text-gray-300 hover:text-gray-100"
				:class="{'text-gray-400 hover:text-gray-400': !$auth.isAuthenticated.value}"
			/>
		</label>
		<input
			id="file-input"
			ref="fileInput"
			class="hidden"
			type="file"
			multiple
			:disabled="isDisabled"
			@input="onAttach"
		/>
	</BaseTooltip>
</template>

<script>
export default {
	name: 'AttachFileButton',
	props: {
		isDisabled: Boolean,
	},
	emits: ['attach'],
	mounted() {
		window.addEventListener('attachmentRemoved', this.onAttachmentRemoved)
	},
	unmounted() {
		window.removeEventListener('attachmentRemoved', this.onAttachmentRemoved)
	},
	methods: {
		onAttach(event) {
			this.$emit('attach', event)
			if (this.$refs?.fileInput) this.$refs.fileInput.value = null
		},
		onAttachmentRemoved() {
			if (this.$refs?.fileInput) this.$refs.fileInput.value = null
		},
	},
}
</script>
